import { useInfiniteQuery } from "react-query"
import EligibilityService from "~services/EligibilityService"

const useUserEligibility = (userId: string) => {
  return useInfiniteQuery(
    ["user-eligibility", userId],
    ({ pageParam = 1 }) =>
      EligibilityService.getEligibilityByUser(userId, { pageParam }),
    {
      enabled: false,
      getNextPageParam: lastPage => lastPage.hasNextPage,
    },
  )
}

export default useUserEligibility
